import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface ResourceDeleteConfirmationProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  documentUrl?: string;
}

export function ResourceDeleteConfirmation({ open, onClose, onConfirm }: ResourceDeleteConfirmationProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle sx={{ fontSize: '18px' }}>Confirm Delete request</DialogTitle>
      <DialogContent sx={{ fontSize: '14px' }}>
        Are you sure you want to request deletion of this resource? This action cannot be undone.
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
          }}
          variant='text'
          disableElevation
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm();
          }}
          variant='contained'
          color='error'
          disableElevation
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ResourceDeleteConfirmation;
